<template minapp="mpx" xlang="wxml">
  <Drawer
    wx:if="{{!repeat}}"
    externStyle="{{customStyle}}"
    headerStyle="{{headerStyle}}"
    show="{{show}}"
    showMask
    showCloseBtn="{{false}}"
    bind:close="closeDrawer"
  >
    <view class="container" wx:class="{{{'no-fee': type === 1}}}" wx:style="{{containerStyle}}">
      <view class="no-fee-content" wx:if="{{type === 1}}">
        <view class="title">{{ worryfreeRightPopTitle }}</view>
        <view class="sub-title"> {{ serviceFee }}元/份，{{ pureDescText }} </view>
        <view class="card-area">
          <view
            class="card-item"
            wx:for="{{worryfreeRightTipsInfo}}"
            wx:class="{{{big: index <= 1}}}"
            wx:key="index"
          >
            <image class="icon" wx:if="{{index > 1}}" src="{{item.icon}}" />
            <view class="icon-container" wx:else>
              <image class="icon big" src="{{item.icon}}" />
            </view>
            <view class="desc-area" wx:class="{{{big: index <= 1}}}">
              <view wx:if="{{item.title}}" class="desc" wx:class="{{{big: index <= 1}}}">{{
                item.title
              }}</view>
              <view class="sub-desc" wx:if="{{item.subhead}}" wx:class="{{{big: index <= 1}}}">{{
                item.subhead
              }}</view>
            </view>
          </view>
        </view>
      </view>
      <view class="have-fee-content" wx:else>
        <view class="train-info">
          <view class="train-station">
            {{ startStation }}<spring-icon class="arrow" w="34" h="12" name="half-right-arrow" />{{
              endStation
            }}
          </view>
          <view class="train-normal">
            <view class="info-item">{{ trainNo }}</view>
            <view class="info-item left-pipe">{{ startTime }}</view>
            <view class="info-item left-pipe">{{ seatType }}</view>
          </view>
          <view class="profit-passgenger">
            <view class="info-item profit right-pipe">退改费用最高¥{{ refundChangePrice }}元</view>
            <view class="info-item passenger">{{ passengerName }}</view>
          </view>
        </view>
        <view class="profit-card">
          <view class="content">
            <view class="header">
              <hlText class="hl-desc" text="{{hlDescText}}" color="#333" hlColor="#FF6400"></hlText>
              <view class="fee">{{ serviceFee }}元/份</view>
            </view>
            <view class="focused">
              <view
                class="focused-item"
                wx:for="{{worryfreeRightTipsInfo.slice(0,2)}}"
                wx:key="index"
              >
                <image wx:if="{{item.icon}}" class="icon" src="{{item.icon}}" />
                <view class="desc">
                  <view wx:if="{{item.title}}" class="title">{{ item.title }}</view>
                  <view wx:if="{{item.subhead}}" class="sub-title">{{ item.subhead }}</view>
                </view>
              </view>
            </view>
            <view class="profit-list">
              <view wx:for="{{worryfreeRightTipsInfo.slice(2)}}" wx:key="index" class="profit-item">
                <view class="icon-container"
                  ><image wx:if="{{item.icon}}" class="icon" src="{{item.icon}}"
                /></view>
                <view class="desc" wx:if="{{item.title}}">{{ item.title }}</view>
              </view>
            </view>
          </view>
        </view>
      </view>
      <view class="btn-area">
        <Button externClass="btn disagree" bindclick="closeDrawerAndSubmit">否</Button>
        <view class="card-button-area">
          <Button externClass="btn agree" bindclick="confirm">是</Button>
          <BubbleBtn class="bubble-btn" wx:if="{{worryFreeCoupon}}" bubbleText="{{worryFreeCoupon}}" />
        </view>
      </view>
    </view>
  </Drawer>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'
  import dayjs from 'dayjs'
  import { RightsTypeMap } from '@/common/constant'
  import 'dayjs/locale/zh-cn'
  import { trackEvent } from '@/common/track'
  import { getStorage, setStorage } from '@/utils/storage'
  import { TICKET_RETENTION_POPUP_TIMES } from '@/utils/train-storage'
  dayjs.locale('zh-cn')

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      currentPassengerList: {
        type: Array,
        value: []
      }
    },
    data() {
      return {
        headerStyle: {
          paddingTop: 0
        },
        containerStyle: {
          backgroundSize: '100% auto',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          borderRadius: '20px 20px 0 0'
        },
        customStyle: {
          borderRadius: '20px 20px 0 0',
          overflow: 'hidden'
        },
        popupId: 10000,
        uniqueId: 'ticket-retention-drawer'
      }
    },
    created() {
      if (__mpx_mode__ == 'web') {
        const curPopupNum = this.uniquePopupMap?.[this.uniqueId] || 0
        this.updateUniquePopupMap({
          [this.uniqueId]: curPopupNum + 1
        })
        this.popupId = curPopupNum + 1
      }
    },
    watch: {
      show: {
        handler(val) {
          if (val && !this.repeat) {
            const preTimesObj = getStorage(TICKET_RETENTION_POPUP_TIMES)
            const preTicketTimesObj = preTimesObj.normal || {}
            const timestamp = preTicketTimesObj.timestamp || 0
            const times = preTicketTimesObj.times || 0
            const curTimestamp = dayjs().unix()
            const isSameDay = dayjs.unix(timestamp).isSame(dayjs.unix(curTimestamp), 'day')
            const updatedTicketTimes = {
              times,
              timestamp
            }
            if (isSameDay) {
              updatedTicketTimes.times = times + 1
            } else {
              updatedTicketTimes.times = 1
            }
            updatedTicketTimes.timestamp = curTimestamp
            setStorage({
              key: TICKET_RETENTION_POPUP_TIMES,
              data: {
                ...preTimesObj,
                normal: updatedTicketTimes
              }
            })
            trackEvent(
              'yks_train_conorder_noworriesfloat_sw',
              '迎客松-火车票-确认订单页-退改无忧浮层-曝光',
              {
                floattype: this.type === 1 ? 'summary' : 'special',
                number: updatedTicketTimes.times
              }
            )
          }
        },
        immediate: true
      }
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
        selectRightInfo: 'train.selectRightInfo',
        trainInfo: 'train.trainInfo',
        uniquePopupMap: 'common.uniquePopupMap'
      }),
      ...store.mapGetters({
        worryFreeCouponInfo: 'makeOrder.worryFreeCouponInfo'
      }),
      repeat() {
        return this.popupId < (this.uniquePopupMap?.[this.uniqueId] || 0)
      },
      startStation() {
        return this.trainInfo?.from_station_name || ''
      },
      endStation() {
        return this.trainInfo?.to_station_name || ''
      },
      trainNo() {
        return this.trainInfo?.train_code || ''
      },
      startTime() {
        return this.trainInfo?.start_time
          ? dayjs(this.trainInfo.start_time).format('M月D日 HH:mm 周dd')
          : ''
      },
      seatType() {
        return this.selectSeatInfo?.[0]?.seat_type_name || ''
      },
      passengerName() {
        return this.currentPassengerList
          .map((item) => item?.passenger_name || '')
          .filter((item) => item)
          .join(' ')
      },
      serviceFee() {
        return getFinalPrice(this.worryfreeRightInfo?.fee || 0)
      },
      refundChangePrice() {
        return getFinalPrice(this.worryfreeRightPopupInfo?.refund_change_price || 0)
      },
      hlDescText() {
        return this.worryfreeRightPopupInfo?.pop_subhead || ''
      },
      pureDescText() {
        return this.hlDescText.replace(/[{}]/g, '')
      },
      worryfreeRightInfo() {
        const rightInfoArr = this.selectSeatInfo.map((item) => {
          const serviceInfo = item?.service_info || {}
          return serviceInfo?.serviceInfoList || {}
        })
        const _worryfreeRightInfo =
          rightInfoArr?.[0]?.find((item) => item.type === RightsTypeMap.worryfree) || {}
        return _worryfreeRightInfo
      },
      worryfreeRightPopupInfo() {
        return this.worryfreeRightInfo?.pop_info || {}
      },
      worryfreeRightTipsInfo() {
        return this.worryfreeRightPopupInfo?.pop_rights_tips || []
      },
      worryfreeRightPopTitle() {
        return this.worryfreeRightPopupInfo?.pop_title || ''
      },
      // 挽留弹窗类型 1为没有费用的 2为有费用的
      type() {
        return this.refundChangePrice ? 2 : 1
      },
      worryFreeCoupon() {
        return this.worryFreeCouponInfo.amount ? `预定立减${this.worryFreeCouponInfo.amount / 100}元` : ''
      }
    },
    methods: {
      ...store.mapMutations({
        closeNormalRetentionDrawer: 'makeOrder.closeNormalRetentionDrawer',
        setAddedServiceSource: 'makeOrder.setAddedServiceSource',
        updateUniquePopupMap: 'common.updateUniquePopupMap'
      }),
      ...store.mapActions({
        changeRightByType: 'makeOrder.changeRightByType'
      }),
      closeDrawer(e) {
        const type = e?.detail.type
        if (type === 'mask') {
          this.ckTrackEvent(2)
        }
        this.closeNormalRetentionDrawer()
      },
      closeDrawerAndSubmit() {
        this.ckTrackEvent(0)
        this.closeNormalRetentionDrawer()
        this.triggerEvent('submit')
      },
      confirm() {
        this.changeRightByType(RightsTypeMap.worryfree)
        this.ckTrackEvent(1)
        this.closeNormalRetentionDrawer()
        const added_service_map = {
          1: '',
          2: 'make_order_float__noworries',
          3: ''
        }
        this.setAddedServiceSource([added_service_map[2]])
        this.triggerEvent('submit')
      },
      ckTrackEvent(button) {
        const preTimesObj = getStorage(TICKET_RETENTION_POPUP_TIMES)
        const preTicketTimesObj = preTimesObj.normal || {}
        const times = preTicketTimesObj.times || 0
        trackEvent(
          'yks_train_conorder_noworriesfloat_ck',
          '迎客松-火车票-确认订单页-退改无忧浮层-点击',
          {
            floattype: this.type === 1 ? 'summary' : 'special',
            button: button === 0 ? '否' : button === 1 ? '是' : '关闭',
            number: times
          }
        )
      }
    },
    detached() {
      if (__mpx_mode__ == 'web') {
        this.updateUniquePopupMap({
          [this.uniqueId]: this.popupId - 1
        })
      }
    }
  })
</script>

<style scoped lang="stylus">
  @font-face
    font-family MFYuanHei
    src url('https://ut-static.udache.com/webx/sfc/ScJsPNeCbzw01nj7OgQuL.otf')
  .container
    position relative
    box-sizing border-box
    padding 28px 20px 38.5px 20px
    display flex
    flex-direction column
    align-items center
    &.no-fee
      padding 31px 20px 38.5px 20px
      background-image url('https://ut-static.udache.com/webx/sfc/VG5_75Y_heVhZ16WVrjpm.png')
    .no-fee-content
      width 100%
      display flex
      flex-direction column
      align-items center
      .title
        font-family MFYuanHei
        font-size 20px
        background linear-gradient(265deg, #582605 0%, #542505 12%, #963F04 29%, #532405 43%, #522405 99%)
        -webkit-background-clip text
        -webkit-text-fill-color transparent
        background-clip text
        margin-bottom 5px
      .sub-title
        position relative
        font-family PingFang SC
        font-size 12px
        font-family PingFangSC-Medium
        font-weight 500
        color #783E17
        margin-bottom 30px
        &::after, &::before
          content ''
          position absolute
          width 44px
          height 1px
          top 50%
          background linear-gradient(270deg, #522404 0%, rgba(82, 36, 4, 0) 99%)
        &::after
          left -8px
          transform translate(-100%, -50%)
        &::before
          right -8px
          transform translate(100%, -50%) rotate(180deg)
      .card-area
        width 100%
        display flex
        flex-wrap wrap
        justify-content space-between
        margin-bottom 26px
        .card-item
          width calc(((100% - 8px) / 2))
          margin-bottom 8px
          display flex
          align-items center
          border-radius 8px
          box-sizing border-box
          padding 16px 0 16px 15px
          background linear-gradient(113deg, rgba(255, 241, 232, 0.3) 7%, rgba(255, 241, 232, 0.3) 7%, rgba(255, 247, 237, 0.3) 47%, rgba(253, 240, 214, 0.3) 89%)
          &.big
            padding 23.5px 0 32.5px 0
            flex-direction column
            opacity 1
            background linear-gradient(180deg, #FFFFFF 33%, #FEFAF2 100%)
            border 0.5px solid #fbead2
            border-radius 16px
          .icon-container
            display flex
            justify-content center
            align-items center
            margin-bottom 25px
            height 55px
            width 55px
            border-radius 15px
            background linear-gradient(139deg, #FFF1E8 4%, rgba(255, 241, 232, 0.9937) 4%, rgba(255, 247, 237, 0.9967) 45%, #FDF0D6 90%)
          .icon
            height 30px
            width 30px
            margin-right 11px
            &.big
              margin-right 0
              height 40px
              width 40px
          .desc-area
            display flex
            flex-direction column
            &.big
              align-items center
            .desc
              color #333
              font-family PingFangSC-Semibold
              font-weight 600
              margin-bottom 6px
              font-size 12px
              line-height 1
              &.big
                font-size 16px
                margin-bottom 9px
            .sub-desc
              color #666
              font-family PingFangSC-Regular
              font-weight 400
              font-size 10px
              line-height 1
              &.big
                font-size 12px
    .have-fee-content
      width 100%
      display flex
      flex-direction column
      margin-bottom 18px
      .train-info
        display flex
        flex-direction column
        justify-content flex-start
        margin-bottom 10px
        .train-station
          display flex
          align-items center
          color #333
          font-size 22px
          line-height 20px
          font-family PingFangSC-Medium
          font-weight 500
          margin-bottom 14px
          .arrow
            margin 0 4px
        .left-pipe
          position relative
          margin-left 16px
          &::before
            position absolute
            content ''
            top 50%
            left -8px
            height 20px
            width 1px
            background #999
            transform scale(0.5) translateY(-100%)
        .right-pipe
          position relative
          margin-right 16px
          &::after
            position absolute
            content ''
            top 50%
            right -8px
            height 20px
            width 1px
            background #999
            transform scale(0.5) translateY(-100%)
        .passenger
          flex 1
          white-space nowrap
          overflow hidden
          text-overflow ellipsis
        .info-item
          font-size 14px
          line-height 1
          color #333
          font-family PingFangSC-Regular
          font-weight 400
        .train-normal
          display flex
          margin-bottom 7px
          align-items center
        .profit-passgenger
          display flex
          align-items center
          .profit
            color #FF6400
            font-family PingFangSC-Medium
            font-weight 500
      .profit-card
        height 263.5px
        background-image url('https://ut-static.udache.com/webx/sfc/JAdl7PMsyEjMKwcu3LRzW.png')
        background-size 100% 100%
        background-repeat no-repeat
        margin 0 -10px
        box-sizing border-box
        padding 45.5px 3px 3px 3px
        display flex
        .content
          display flex
          flex-direction column
          width 100%
          flex 1
          border-radius 10px
          background #fff
          padding 12px 13px 25px 12px
          box-sizing border-box
          .header
            display flex
            justify-content space-between
            align-items center
            margin-bottom 12px
            .hl-desc
              font-size 12px
              font-family PingFangSC-Medium
              font-weight 500
            .fee
              font-size 11px
              line-height 10px
              color #666
              font-family PingFangSC-Regular
              font-weight 400
          .focused
            width 100%
            box-sizing border-box
            padding 20.5px 18px
            display flex
            justify-content space-between
            background linear-gradient(105deg, rgba(255, 241, 232, 0.4) 8%, rgba(255, 241, 232, 0.4) 8%, rgba(255, 247, 237, 0.4) 47%, rgba(253, 240, 214, 0.4) 89%)
            border-radius 8px
            margin-bottom 12px
            .focused-item
              display flex
              width 50%
              align-items center
              .icon
                height 33px
                width 33px
                margin-right 10px
              .desc
                display flex
                flex-direction column
                .title
                  font-size 14px
                  line-height 12px
                  font-family PingFangSC-Medium
                  font-weight 500
                  color #333
                  margin-bottom 8px
                .sub-title
                  font-size 11px
                  line-height 10px
                  color #999
                  font-family PingFangSC-Regular
                  font-weight 400
          .profit-list
            display grid
            grid-template-columns repeat(3, 1fr)
            grid-template-rows auto auto
            grid-row-gap 12px
            grid-column-gap 14px
            .profit-item
              display flex
              align-items center
              // 3的倍数的iten
              &:nth-child(3n)
                justify-content flex-end
              .icon-container
                width 28px
                height 28px
                display flex
                justify-content center
                align-items center
                border-radius 8px
                margin-right 8px
                background linear-gradient(139deg, #FFF1E8 4%, rgba(255, 241, 232, 0.9937) 4%, rgba(255, 247, 237, 0.9967) 45%, #FDF0D6 90%)
              .icon
                height 22px
                width 22px
              .desc
                font-family PingFangSC-Medium
                font-weight 500
                font-size 12px
                line-height 1
                color #333
    .btn-area
      width 100%
      display flex
      justify-content space-between
      .btn
        border-radius 8px
        box-sizing border-box
        display flex
        justify-content center
        align-items center
        font-size 16px
        padding 14px 0
      .disagree
        color #999
        font-family PingFangSC-Medium
        font-weight 500
        width 109px
        margin-right 8px
        border 1px solid #ccc
      .agree
        font-family PingFangSC-Semibold
        font-weight 600
        background #FF6400
        color #fff
        flex 1
      .card-button-area
        position relative
        flex 1
      .bubble-btn
        position absolute
        top -10px
        right 0
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      Drawer: '@didi/spring-ui/ts-drawer',
      Button: '@didi/spring-ui/ts-button',
      'BubbleBtn': '@/pages/home/components/bubble-btn',
      'spring-icon': '@didi/spring-icon',
      hlText: '@didi/spring-ui/hl-text'
    }
  }
</script>